export enum MessageType {
  text = 1,
  card_button_list = 2, // 我的待办(1)
  todo_list = 3, // 待办
  phone = 4,
  question_list_intention = 10,
  img = 11,
  /**
   * 大模型资料列表（支持链接跳转）
   */
  file_list_link = 300,
  /**
   * 大模型图片
   */
  llm_img = 301,
  /**
   * 大模型视频
   */
  llm_video = 302,
  staff_list = 14, // 员工列表
  skill_list = 15,
  WeChat_qrcode = 16,
  super_link = 17,
  welcome_letter = 18,
  question_list_recommend = 19,
  card_notice_carousel = 20,
  card_hot_faq_and_category = 21,
  card_file = 22,
  card_video = 23,
  score = 24,
  card_workbench = 27,
  card_tickets = 28,
  contact_card = 100,
  feedback = 202,
  button_list = 201,
  notice = 206,
  
  REGION_ASSESSMENT_INFO = 29,
  COMPANY_ASSESSMENT_INFO = 30,
  PERSONAL_ASSESSMENT_INFO = 31,

  client_msg = "client_msg",
  client_phone_msg = "client_phone_msg",
  client_chose_companies = "client_chose_companies",
  client_agreement = "client_agreement",
  client_receive_loading = "client_receive_loading",
  client_authcode_countdown = "client_authcode_countdown",
  client_send_loading = "client_send_loading",
  client_recording = "client_recording",

  client_timestamp = "client_timestamp",
  system_info_msg = "system_msg",
}

export enum LoginFlow {
  inputPhoneNumber = "inputPhoneNumber",
  signAgreement = "signAgreement",
  inputAuthcode = "inputAuthcode",
  choseCompany = "choseCompany",
  loginWithCode = "loginWithCode",
  LoggedIn = "LoggedIn",
}

export enum MessageFrom {
  BOT = "BOT",
  OTHERS = "OTHERS",
  SELF = "SELF",
  SYSTEM = "SYSTEM",
  AI = 'AI'
}
export interface ServerMessage {
  type: MessageType;
  data: any;
}

export interface ClientMessage {
  id: string;
  time: number;
  from: MessageFrom;
  messages: ServerMessage[];
  name?: string;
  read?: boolean;
  avatar?: string;
  fromHistory?: boolean;
}

export type Messages = ClientMessage[];

export enum FeedbackType {
  button_list = 203,
  validator = 205,
}

export interface IQuestion {
  action: number;
  callback: any;
  text: string;
}

export type Questions = IQuestion[];

export interface ISkill {
  action: number;
  callback: any;
  detail: any;
  icon: string;
  name: string;
  type: number;
}

export interface IMenu {
  knowledge_base: {
    name: string;
    skills: ISkill[];
  };
  workbench: {
    name: string;
    workbench_sub_groups: {
      name: string;
      skills: ISkill[];
    }[];
  };
  show: boolean;
}

export enum ChatMode {
  LOGIN = "LOGIN",
  BOT = "BOT",
  IM = "IM",
}

export interface MsgContent {
  text: string;
}

export interface MsgBody {
  msgType: string;
  msgContent: MsgContent;
}

export interface RoamMsg {
  fromAccount: string;
  toAccount: string;
  msgSeq: number;
  msgRandom: number;
  msgTimeStamp: number;
  msgFlagBits: number;
  msgKey: string;
  msgBody: MsgBody[];
}

export interface DoubleCheck {
  title: string;
  positiveMessage: string;
  negativeMessage: string;
}

export interface Button {
  text: string;
  action: number;
  feedBackUse: boolean;
  doubleCheck: DoubleCheck;
  callback: any;
}

export interface Conversation {
  to_user_name: string;
  to_user_avatar: string;
  to_user_id: string;
  from_user_id: string;
  finish: boolean;
  ex_msgs: RoamMsg[][];
  msgs: RoamMsg[];
  buttons: Button[];
  task_id: string;
  prologues: string[];
  end_of_non_operation: {
    end_remind_msg: string;
    time: number;
    enable: boolean;
  };
  conversation_id: string;
  read_status_visible: boolean;
}

export enum IMEventTye {
  B_invite_evaluation = 1,
  conversation_ended = 2,
  conversation_transferred = 3,
}
